import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { JupiterInspectionInfo } from '../../types/jupiter-inspection-info.type';

@Component({
  selector: 'app-lot-moto-jupiter-inspection-card-title',
  templateUrl: './lot-moto-jupiter-inspection-card-title.component.html',
  styleUrls: ['./lot-moto-jupiter-inspection-card-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotMotoJupiterInspectionCardTitleComponent {
  @Input() inspectionInfo: JupiterInspectionInfo;

  get score(): string | null {
    return this.inspectionInfo.score || null;
  }
}
